import { gql } from '@apollo/client';

export const APPROVE_TEMPLATE_CONTENT_BUILD_EMAIL_PREVIEWS_MUTATION = gql`
    mutation ApproveTemplateContentBuildEmailPreviewsMutation($input: ApproveTemplateContentBuildEmailPreviewInput!) {
        approveTemplateContentBuildEmailPreviews(input: $input) {
            templateContentBuildEmailPreviews {
                id
            }
        }
    }
`;
